import script from "./HeaderSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSlider.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSlider.vue?vue&type=style&index=0&id=69c139c7&lang=scss"

const __exports__ = script;

export default __exports__